import SystemGroup from './SystemGroupNeo.vue';
export default SystemGroup;
